import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TSortColumn, TSortDirection } from '../../classes/grid-page-info';
import {
  GQLArguments,
  GQLResponse,
  IGQLResponse,
} from '../../interfaces/graphql.interface';
import {
  getInsuranceQuery,
  getInsurancesQuery,
} from '../../interfaces/insurance/insurance.graphql';
import {
  IGQLInsuranceParams,
  IInsurance,
  InsuranceCompanySearchResponseConnection,
} from '../../interfaces/insurance/insurance.interface';
import { HelperGQLService } from '../helper.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class InsuranceGQLService {
  constructor(
    private apollo: Apollo,
    private gqlService: HelperGQLService,
  ) {}

  getInsurances(
    payersParams?: IGQLInsuranceParams,
  ): Observable<GQLResponse<InsuranceCompanySearchResponseConnection>> {
    const { orderby, direction, filter, after } = payersParams ?? {};
    const sortBy: TSortColumn | undefined = orderby;
    const sortDirection: TSortDirection | undefined = direction;

    const gqlArguments: GQLArguments = {
      first: 30,
    };

    if (filter) {
      const eraFilters = {
        formatType: filter.formatType ? { eq: filter.formatType } : null,
        insuranceCode: filter.insuranceCode
          ? { eq: filter.insuranceCode }
          : null,
        name: filter.name ? { contains: filter.name } : null,
        recId: filter.recId ? { eq: filter.recId } : null,
        recordStatus: filter.recordStatus
          ? { eq: filter.recordStatus[0] }
          : null,
        requiresEnrollment: filter.requiresEnrollment
          ? { eq: filter.requiresEnrollment }
          : null,
        ediId: { eq: filter.ediId },
        processorId: { eq: filter.processorId },
      };
      gqlArguments.where = this.gqlService.cleanFilterObject(eraFilters);
    }

    // const gqlFilters = this.gqlService.cleanFilterObject(accountFilters);
    // console.log(gqlFilters);

    // if (gqlFilters) gqlArguments.where = gqlFilters;
    if (sortBy && sortDirection) {
      gqlArguments.order = [{ [sortBy]: sortDirection }];
    }
    if (after) {
      gqlArguments.after = after;
    }

    return this.apollo
      .watchQuery<IGQLResponse<InsuranceCompanySearchResponseConnection>>({
        query: getInsurancesQuery,
        fetchPolicy: 'no-cache',
        variables: {
          ...gqlArguments,
        },
      })
      .valueChanges.pipe(
        map((response) => {
          return response.data.insuranceCompanies;
        }),
      );
  }

  getInsurance(insuranceID?: number): Observable<string> {
    return this.apollo
      .watchQuery<IInsurance>({
        query: getInsuranceQuery,
        fetchPolicy: 'no-cache',
        variables: {
          recId: insuranceID,
        },
      })
      .valueChanges.pipe(
        map((response) => {
          return response.data.insuranceCompany;
        }),
      );
  }
}
